// import React from 'react'
// import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom'
import Layout from "./components/Layout";

import Login from "./pages/auth/login";
import ForgotPassword from "./pages/auth/ForgotPassword";
import LoginOTP from "./pages/auth/LoginOTP";
import SetPassword from "./pages/auth/SetPassword";
// import UserDetails from './pages/UserDetails'
import Settings from "./pages/settings";
// import CreateUser from './pages/CreateUser'
// import Modules from './pages/Modules'
import UserDetails from "./pages/app-user";
import "./App.css";
import ReportsAnalytics from "./pages/data-reports/report-and-analytics";
import SupportTicket from "./pages/support-ticket";
import UserList from "./pages/user-management/user-list";
import Roles from "./pages/user-management/roles";
import {
  BrowserRouter,
  Route,
  Router,
  Routes,
  useLocation,
} from "react-router-dom";
import ProtectedRoute from "../src/routes/ProtectedRoute";
import PublicRoute from "../src/routes/PublicRoute";
import CommonRouter from "./routes/CommonRouter";

// const AuthWrapper = ({ children }: { children: React.ReactNode }) => {
//   const location = useLocation()
//   const authRoutes = ['/', '/forgot-password', '/login-otp', '/set-password']
//   const isAuthRoute = authRoutes.includes(location.pathname)

//   return (
//     <div className={isAuthRoute ? 'auth-bg' : ''}>
//       {children}
//     </div>
//   )
// }

// const App = () => {
//   return (
//     <BrowserRouter>
//       <AuthWrapper>
//         <Routes>
//           {/* Auth pages - without sidebar */}
//           <Route path="/" element={<Login />} />
//           <Route path="/forgot-password" element={<ForgotPassword />} />
//           <Route path="/login-otp" element={<LoginOTP />} />
//           <Route path="/set-password" element={<SetPassword />} />

//           {/* Dashboard pages - with sidebar */}
//           <Route element={<Layout />}>
//             <Route path="/user-lists" element={<UserDetails />} />
//             <Route path="/settings" element={<Settings />} />
//             <Route path="/app-users" element={<UserDetails />} />
//             <Route path="/reports-analytics" element={<ReportsAnalytics />} />
//             <Route path="/support-ticket" element={<SupportTicket />} />
//             <Route path="/user-management/user-list" element={<UserList />} />
//             <Route path="/user-management/roles" element={<Roles />} />
//           </Route>
//         </Routes>
//       </AuthWrapper>
//     </BrowserRouter>
//   )
// }

// export default App
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// In your root component:

const App = () => {
  return (
    <BrowserRouter>
      {/* <ToastContainer /> */}
      <ToastContainer
        autoClose={1500} //
        position="top-right"
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        pauseOnHover
        draggable
        theme="light"
        limit={3}
      />

      <CommonRouter />
    </BrowserRouter>
  );
};

export default App;
